export default {

  jpg: {
    typeName: 'IMG',
    fileExtension: '.img',
    viewerComponent: 'image-file-viewer'
  },

  txt: {
    typeName: 'TXT',
    fileExtension: '.txt',
    viewerComponent: 'text-file-viewer'
  }

}
